<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <create-reportnotregis></create-reportnotregis>
    </div>
  </div>
</template>

<script>
import CreateReportnotregis from "../../components/CreateReportnotregis.vue";

export default {
  components: {
    CreateReportnotregis
  },
  name: "Reportnotregis",
  data() {
    return {
      items: [],
      categorey: []
    };
  },
  methods: {},
  mounted() {},
  created() {}
};
</script>
<style></style>
